export * from './MediaUiRectPlayIcon';
export * from './MediaUiRectPlayIcon16Light';
export * from './MediaUiRectPlayIcon16Regular';
export * from './MediaUiRectPlayIcon16Solid';
export * from './MediaUiRectPlayIcon20Light';
export * from './MediaUiRectPlayIcon20Regular';
export * from './MediaUiRectPlayIcon20Solid';
export * from './MediaUiRectPlayIcon24Regular';
export * from './MediaUiRectPlayIcon24Solid';
export * from './MediaUiRectPlayIcon32Regular';
export * from './MediaUiRectPlayIcon64Regular';
